module.exports = __webpack_public_path__ + "img/feature-grid.25e953c1.png";